export const updateProductStatusMutation = /* GraphQL */ `
  mutation UpdateProductStatus($input: UpdateProductStatusInput!) {
    updateProductStatus(input: $input) {
      id
      updatedAt
    }
  }
`
export const createProductMutation = /* GraphQL */ `
  mutation CreateProduct(
    $productInput: CreateProductInput!
    $productStatusInput: CreateProductStatusInput!
  ) {
    createProduct(input: $productInput) {
      createdAt
    }
    createProductStatus(input: $productStatusInput) {
      createdAt
    }
  }
`
export const createProductWithStatusMutation = /* GraphQL */ `
  mutation CreateProductWithStatus($input: CreateProductWithStatusInputInput!) {
    createProductWithStatus(input: $input) {
      product {
        id
        createdAt
      }
      productStatus {
        id
        productID
        createdAt
        updatedAt
      }
    }
  }
`
export const splitProductWithStatusMutation = /* GraphQL */ `
  mutation SplitProductWithStatus($input: SplitProductWithStatusInputInput!) {
    splitProductWithStatus(input: $input) {
      outcome
      commandID
      sourceStatusID
      productID
      productStatusID
      committedResidualQuantity {
        number
        unit
      }
      committedSourceUpdatedAt
      requiresCanonicalRefetch
    }
  }
`
export const closeAndCreateProductStatusMutation = /* GraphQL */ `
  mutation CloseAndCreateProductStatusMutation(
    $previousStatusInput: UpdateProductStatusInput!
    $input: CreateProductStatusInput!
  ) {
    updateProductStatus(input: $previousStatusInput) {
      updatedAt
    }
    createProductStatus(input: $input) {
      createdAt
    }
  }
`
export const createProductStatusMutation = /* GraphQL */ `
  mutation CreateProductStatus($input: CreateProductStatusInput!) {
    createProductStatus(input: $input) {
      createdAt
    }
  }
`

export const createShopMutation = /* GraphQL */ `
  mutation CreateShop($input: CreateShopInput!) {
    createShop(input: $input) {
      createdAt
    }
  }
`
export const updateShopMutation = /* GraphQL */ `
  mutation UpdateShop($input: UpdateShopInput!) {
    updateShop(input: $input) {
      updatedAt
    }
  }
`
export const createPlaceMutation = /* GraphQL */ `
  mutation CreatePlace($input: CreatePlaceInput!) {
    createPlace(input: $input) {
      createdAt
    }
  }
`

export const updatePlaceMutation = /* GraphQL */ `
  mutation UpdatePlace($input: UpdatePlaceInput!) {
    updatePlace(input: $input) {
      updatedAt
    }
  }
`

export const deletePlaceMutation = /* GraphQL */ `
  mutation DeletePlace($id: ID!) {
    deletePlace(input: { id: $id }) {
      id
    }
  }
`
export const createProjectMutation = /* GraphQL */ `
  mutation CreateProject($input: CreateProjectInput!) {
    createProject(input: $input) {
      createdAt
    }
  }
`

export const updateProjectMutation = /* GraphQL */ `
  mutation updateProject($input: UpdateProjectInput!) {
    updateProject(input: $input) {
      updatedAt
    }
  }
`

export const updateOrderMutation = /* GraphQL */ `
  mutation updateOrderSignStatus($input: UpdateOrderInput!) {
    updateOrder(input: $input) {
      updatedAt
    }
  }
`

export const createOrderMutation = /* GraphQL */ `
  mutation createOrder(
    $input: CreateOrderInput!
    $condition: ModelOrderConditionInput
  ) {
    createOrder(input: $input, condition: $condition) {
      id
      createdAt
    }
  }
`

export const createSavedSearchMutation = /* GraphQL */ `
  mutation CreateSavedSearch($input: CreateSavedSearchInput!) {
    createSavedSearch(input: $input) {
      id
      createdAt
    }
  }
`

export const updateSavedSearchMutation = /* GraphQL */ `
  mutation UpdateSavedSearch($input: UpdateSavedSearchInput!) {
    updateSavedSearch(input: $input) {
      id
      updatedAt
    }
  }
`

export const deleteSavedSearchMutation = /* GraphQL */ `
  mutation DeleteSavedSearch($input: DeleteSavedSearchInput!) {
    deleteSavedSearch(input: $input) {
      id
    }
  }
`

export const upsertTeamGridViewMutation = /* GraphQL */ `
  mutation UpsertTeamGridView($input: GridViewTeamViewWriteInputInput!) {
    upsertTeamGridView(input: $input) {
      id
      createdAt
      updatedAt
    }
  }
`

export const upsertGridViewPreferenceMutation = /* GraphQL */ `
  mutation UpsertGridViewPreference($input: GridViewPreferenceInputInput!) {
    upsertGridViewPreference(input: $input) {
      status
      revision
      preference {
        id
        kind
        organizationID
        scopeKey
        userID
        selectedViewRef
        draftPayload
        payloadVersion
        gridSchemaVersion
        status
        createdAt
        updatedAt
        revision
        source
      }
    }
  }
`

export const createProductBatchMutation = /* GraphQL */ `
  mutation CreateProductBatch($input: CreateProductBatchInput!) {
    createProductBatch(input: $input) {
      createdAt
    }
  }
`
export const createProductBatchAndStatusMutation = /* GraphQL */ `
  mutation CreateProductBatch(
    $productBatchInput: CreateProductBatchInput!
    $productStatusInput: CreateProductStatusInput!
  ) {
    createProductBatch(input: $productBatchInput) {
      createdAt
    }
    createProductStatus(input: $productStatusInput) {
      createdAt
    }
  }
`

export const updatedProductBatchMutation = /* GraphQL */ `
  mutation UpdateProductBatch($input: UpdateProductBatchInput!) {
    updateProductBatch(input: $input) {
      updatedAt
    }
  }
`
export const createReviewMutation = /* GraphQL */ `
  mutation CreateReview(
    $input: CreateReviewInput!
    $condition: ModelReviewConditionInput
  ) {
    createReview(input: $input, condition: $condition) {
      createdAt
    }
  }
`
export const updateReviewMutation = /* GraphQL */ `
  mutation UpdateReview(
    $input: UpdateReviewInput!
    $condition: ModelReviewConditionInput
  ) {
    updateReview(input: $input, condition: $condition) {
      updatedAt
    }
  }
`
